<template>

    <Title>Policy Manuals</Title>

    <Heading1 class="mb-4">Policy manuals</Heading1>

    <section class="pt-6">

        <div v-if="policyManuals.length === 0" class="px-8 py-12 flex flex-col items-center gap-y-4 text-gray-700">
            <h2 class="text-xl font-medium">No policy manuals yet</h2>
        </div>

        <div v-else class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <NuxtLink
                v-for="policy in policyBooksData" :to="`/${publicSiteData.slug}/policies/${policy.slug}`"
                class="p-8 bg-white border-gray-400 border rounded-lg flex flex-col"
            >
                <font-awesome :icon="['fad', 'book']" class="text-primary self-center w-14 h-16 mb-6" />
                <h2 class="font-medium mb-1 line-clamp-2" :title="policy.title">{{policy.title}}</h2>
                <div class="text-gray-700 mt-auto text-sm">Last updated {{policyLastUpdated(policy)}}</div>
            </NuxtLink>
        </div>

    </section>
</template>


<script setup>
import Heading1 from "~/components/public/Heading1.vue";

const publicSiteData = useState('publicSiteData');
const { data: policyBooksData } = await publicFetch(`/public-sites/policy-books`);
const policyManuals = ref([{ id: 'some-id', name: 'Policy name', updated: 'Now' }]);
let policyLastUpdated = (policy) => {
    const date = new Date(policy.updated_at.date);
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear().toString().slice(-2)}`;
}
</script>

